import { baseApi } from './baseApi'
import { IAppStatus } from '../../types/appStatus'

export const appStatusApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAppStatus: builder.query<IAppStatus, void>({
      query: () => '/auth/app-status',
      providesTags: ['AppStatus'],
    }),
    updateAppStatus: builder.mutation<void, Partial<IAppStatus>>({
      query: (body) => ({
        url: '/auth/app-status',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['AppStatus'],
    }),
  }),
})

export const { useGetAppStatusQuery, useUpdateAppStatusMutation } = appStatusApi
